import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const textEncode = (content: string): Uint8Array => {
  return new TextEncoder().encode(content);
};

export const textDecode = (content: Uint8Array): string => {
  return new TextDecoder().decode(content);
};

export const baseUrl = (): string => {
  const url = process.env.NEXT_PUBLIC_URL;
  if (!url) {
    throw new Error('NEXT_PUBLIC_URL environment variable is not set');
  }
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

export const fullUrl = (path: string): string => {
  if (!path || path.trim() === '') {
    throw new Error('Missing path parameter');
  }

  return baseUrl() + path;
}

export function trackEmailOpen(ref: string): string {
  return fullUrl(`/e?r=${encodeURIComponent(ref)}`);
}

export function trackEmailLinkClick(link: string, ref: string): string {
  return fullUrl(`/e?l=${encodeURIComponent(link)}&r=${encodeURIComponent(ref)}`);
}

export function trackLinkClick(link: string): string {
  return fullUrl(`/l?l=${encodeURIComponent(link)}`);
}

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const generateReference = (): string => {
  return `${Math.random().toString(36).substring(2, 6).toLowerCase()}${Math.random().toString(36).substring(2, 6).toLowerCase()}${Math.random().toString(36).substring(2, 6).toLowerCase()}`;
}